import React, { useState } from "react";

import _ from "lodash";
import { safeParseLocalStorage } from "../utils/safeParseLocalStorage";

export const ProfielContext = React.createContext({
  profiel: {},
  setProfiel: () => { },
  setDisabled: () => { },
});

const ProfielContextProvider = (props) => {
  const [profiel, setProfiel] = useState(safeParseLocalStorage("profiel", {}));

  const profielHandler = (data) => {
    setProfiel(_.merge(profiel, data));
    localStorage.setItem("profiel", JSON.stringify(_.merge(profiel, data)));
  };

  const logout = () => {
    // props.myprops.onStateChange("signedOut", null);
  };

  return (
    <ProfielContext.Provider
      value={{ stelprofiel: profielHandler, profiel: profiel, logout: logout }}
    >
      {props.children}
    </ProfielContext.Provider>
  );
};

export default ProfielContextProvider;
